// Pobierz element HTML, w którym będą wyświetlane posty
const $8c6c353d2145b82d$var$postContainer = document.querySelector('#post-container');
// Definiujemy hashtagi, których będziemy używać do filtrowania
const $8c6c353d2145b82d$var$hashtags = {
    all: '#galeria',
    artCakes: '#tort',
    meringue: '#beza',
    wedding: '#weddingcake',
    pie: "#ciastazielonag\xf3ra",
    dessert: '#deser',
    candyBar: '#candybar'
};
function $8c6c353d2145b82d$var$displayPosts(hashtag) {
    $8c6c353d2145b82d$var$postContainer.innerHTML = ''; // Wyczyść kontener przed dodaniem nowych postów
    // Dodaj placeholdery
    for(let i = 0; i < 6; i++){
        const skeletonDiv = document.createElement('div');
        skeletonDiv.classList.add('skeleton', 'col-12', 'col-sm-6', 'col-lg-4');
        $8c6c353d2145b82d$var$postContainer.appendChild(skeletonDiv);
    }
    // Sprawdź, czy posty są zapisane w sessionStorage
    const cachedData = sessionStorage.getItem('cachedPosts');
    if (cachedData) {
        // Jeśli posty są zapisane w sessionStorage, odczytaj i wyświetl je
        const data = JSON.parse(cachedData);
        $8c6c353d2145b82d$var$renderPosts(data, hashtag);
    } else // Pobierz posty z serwera i zapisz je w sessionStorage
    fetch('/.netlify/functions/getPosts').then((response)=>response.json()).then((data)=>{
        sessionStorage.setItem('cachedPosts', JSON.stringify(data)); // Zapisz dane w sessionStorage
        $8c6c353d2145b82d$var$renderPosts(data, hashtag); // Wyświetl pobrane posty
    }).catch((error)=>console.error("B\u0142\u0105d w pobieraniu post\xf3w:", error));
}
function $8c6c353d2145b82d$var$renderPosts(posts, hashtag) {
    $8c6c353d2145b82d$var$postContainer.innerHTML = ''; // Wyczyść kontener na posty
    // Iteracja przez posty i tworzenie ich elementów
    posts.forEach((post)=>{
        if (hashtag === '' || post.caption && post.caption.includes(hashtag)) {
            // Tworzenie elementu posta
            const postDiv = document.createElement('div');
            postDiv.classList.add('item'); // Klasa zgodna z układem masonry
            // Blok cytatu dla osadzania Instagrama
            const blockquote = document.createElement('blockquote');
            blockquote.classList.add('instagram-media');
            blockquote.setAttribute('data-instgrm-permalink', post.permalink);
            blockquote.setAttribute('data-instgrm-version', '16');
            postDiv.appendChild(blockquote);
            $8c6c353d2145b82d$var$postContainer.appendChild(postDiv);
        }
    });
    // Procesowanie iframe dla Instagrama
    const existingScript = document.querySelector('script[src="//www.instagram.com/embed.js"]');
    if (existingScript) existingScript.remove();
    setTimeout(()=>{
        const script = document.createElement('script');
        script.async = true;
        script.src = "//www.instagram.com/embed.js";
        document.body.appendChild(script);
        script.onload = ()=>{
            window.instgrm.Embeds.process();
        };
    }, 100);
}
const $8c6c353d2145b82d$var$currentPage = window.location.href;
document.addEventListener('DOMContentLoaded', ()=>{
    if ($8c6c353d2145b82d$var$currentPage.includes("gallery")) {
        document.getElementById('all').addEventListener('click', ()=>$8c6c353d2145b82d$var$displayPosts($8c6c353d2145b82d$var$hashtags.all));
        document.getElementById('cake-artistic').addEventListener('click', ()=>$8c6c353d2145b82d$var$displayPosts($8c6c353d2145b82d$var$hashtags.artCakes));
        document.getElementById('cake-meringue').addEventListener('click', ()=>$8c6c353d2145b82d$var$displayPosts($8c6c353d2145b82d$var$hashtags.meringue));
        document.getElementById('cake-wedding').addEventListener('click', ()=>$8c6c353d2145b82d$var$displayPosts($8c6c353d2145b82d$var$hashtags.wedding));
        document.getElementById('pie').addEventListener('click', ()=>$8c6c353d2145b82d$var$displayPosts($8c6c353d2145b82d$var$hashtags.pie));
        document.getElementById('dessert').addEventListener('click', ()=>$8c6c353d2145b82d$var$displayPosts($8c6c353d2145b82d$var$hashtags.dessert));
        document.getElementById('candy-bar').addEventListener('click', ()=>$8c6c353d2145b82d$var$displayPosts($8c6c353d2145b82d$var$hashtags.candyBar));
        // Domyślne wyświetlanie postów przy ładowaniu strony
        $8c6c353d2145b82d$var$displayPosts($8c6c353d2145b82d$var$hashtags.all); // Domyślnie bez filtra, wyświetl wszystkie
    }
});
// Funkcja do przewijania na górę strony
class $8c6c353d2145b82d$var$ScrollButton {
    constructor(){
        this.mybutton = document.getElementById("scrollToTopBtn");
        window.onscroll = ()=>this.scrollFunction();
        if (this.mybutton) this.mybutton.addEventListener("click", ()=>this.scrollToTop());
    }
    scrollFunction() {
        if (document.body.scrollTop > 2000 || document.documentElement.scrollTop > 2000) {
            this.mybutton.style.display = "block";
            this.mybutton.style.opacity = "1";
        } else {
            this.mybutton.style.opacity = "0";
            this.mybutton.style.display = "none";
        }
    }
    scrollToTop() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }
}
// Upewnij się, że postContainer istnieje
if ($8c6c353d2145b82d$var$postContainer) {
    // Obserwator zmian DOM
    const observer = new MutationObserver(()=>{
        $8c6c353d2145b82d$var$adjustInstagramIframes(); // Dostosuj iframe'y po dodaniu nowych elementów
    });
    observer.observe($8c6c353d2145b82d$var$postContainer, {
        childList: true,
        subtree: true
    });
} else console.error("Element #post-container nie zosta\u0142 znaleziony.");
// Funkcja do dostosowywania iframe
function $8c6c353d2145b82d$var$adjustInstagramIframes() {
    const iframes = document.querySelectorAll('iframe');
    iframes.forEach((iframe)=>{
        iframe.style.minWidth = '0'; // Próba nadpisania min-width
        iframe.style.width = '100%'; // Pełna szerokość rodzica
    });
}
// Nasłuchiwanie załadowania iframe z Instagrama
window.addEventListener('load', ()=>{
    $8c6c353d2145b82d$var$adjustInstagramIframes();
});
document.addEventListener('DOMContentLoaded', function() {
    const buttons = document.querySelectorAll('.filter__button');
    const defaultButton = document.getElementById('all');
    // Ustawienie domyślnego aktywnego przycisku
    defaultButton.classList.add('active');
    // Obsługa kliknięć i zmiana aktywnego przycisku
    buttons.forEach((button)=>{
        button.addEventListener('click', function() {
            buttons.forEach((btn)=>btn.classList.remove('active'));
            this.classList.add('active');
        });
    });
});
var $8c6c353d2145b82d$export$2e2bcd8739ae039 = $8c6c353d2145b82d$var$ScrollButton;


//# sourceMappingURL=gallery.027e5e91.js.map
